"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SamplesByMonth = void 0;
var React = require("react");
var react_chartjs_2_1 = require("react-chartjs-2");
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var labels = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];
var SamplesByMonth = function (_a) {
    var samplesByMonth = _a.samplesByMonth, _b = _a.headerText, headerText = _b === void 0 ? 'Monthly Sample Results' : _b, textColor = _a.textColor;
    return (React.createElement(React.Fragment, null,
        React.createElement(MonthlySamplesHeader, { textColor: textColor },
            React.createElement("h6", null, headerText)),
        React.createElement("div", { style: { height: '150px' } },
            React.createElement(react_chartjs_2_1.Bar, { options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        backgroundColor: '#18333C',
                        bodyFontColor: '#FFFFFF',
                        bodyFontFamily: 'museo-sans, sans-serif',
                        bodyFontStyle: 'normal',
                        bodyFontSize: 12,
                        titleFontColor: '#FFFFFF',
                        titleFontFamily: 'museo-sans, sans-serif',
                        titleFontStyle: 'normal',
                        titleFontSize: 12,
                        footerFontColor: '#FFFFFF',
                        footerFontFamily: 'museo-sans, sans-serif',
                        footerFontStyle: 'normal',
                        footerFontSize: 12,
                        displayColors: false,
                        xPadding: 8,
                        yPadding: 8,
                        cornerRadius: 4,
                        callbacks: {
                            title: function () { return ''; },
                        },
                    },
                    legend: {
                        display: false,
                        labels: {
                            fontColor: textColor || 'rgba(255,255,255,0.9)',
                        },
                    },
                    scales: {
                        xAxes: [
                            {
                                categoryPercentage: 0.3,
                                ticks: {
                                    fontColor: textColor || 'rgba(255, 255, 255, 0.5)',
                                    fontFamily: '"museo-sans", sans-serif',
                                },
                                stacked: true,
                                gridLines: {
                                    display: false,
                                    zeroLineColor: 'rgba(255, 255, 255, 0.5)',
                                    color: [textColor || 'rgba(255, 255, 255, 0.5)'],
                                },
                            },
                        ],
                        yAxes: [
                            {
                                ticks: {
                                    min: 0,
                                    fontColor: textColor || 'rgba(255, 255, 255, 0.5)',
                                    fontFamily: '"museo-sans", sans-serif',
                                    callback: makeVerticalLinesWholeNumbers,
                                },
                                stacked: true,
                                gridLines: {
                                    borderDash: [1, 4],
                                    zeroLineColor: 'rgba(255, 255, 255, 0.5)',
                                    color: [textColor || 'rgba(255, 255, 255, 0.5)'],
                                },
                            },
                        ],
                    },
                }, data: {
                    labels: labels,
                    datasets: [
                        {
                            label: 'Non-Detects',
                            backgroundColor: theme_1.colors.success,
                            borderColor: theme_1.colors.success,
                            borderWidth: 1,
                            hoverBackgroundColor: theme_1.theme.buttons.success.pressed,
                            hoverBorderColor: theme_1.theme.buttons.success.pressed,
                            data: samplesByMonth.nonDetects,
                        },
                        {
                            label: 'Detects',
                            backgroundColor: theme_1.colors.warning,
                            borderColor: theme_1.colors.warning,
                            borderWidth: 1,
                            hoverBackgroundColor: theme_1.theme.buttons.warning.pressed,
                            hoverBorderColor: theme_1.theme.buttons.warning.pressed,
                            data: samplesByMonth.detects,
                        },
                        {
                            label: 'Exceedances',
                            backgroundColor: theme_1.colors.error,
                            borderColor: theme_1.colors.error,
                            borderWidth: 1,
                            hoverBackgroundColor: theme_1.theme.buttons.error.pressed,
                            hoverBorderColor: theme_1.theme.buttons.error.pressed,
                            data: samplesByMonth.exceedances,
                        },
                    ],
                } }))));
};
exports.SamplesByMonth = SamplesByMonth;
var MonthlySamplesHeader = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  color: ", ";\n\n  & > h6 {\n    margin-bottom: 0.66rem;\n    font-weight: bold;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  color: ", ";\n\n  & > h6 {\n    margin-bottom: 0.66rem;\n    font-weight: bold;\n  }\n"
    // @ts-ignore:noImplicitAny
])), function (props) { return props.textColor || props.theme.colors.white; });
// @ts-ignore:noImplicitAny
var makeVerticalLinesWholeNumbers = function (value) {
    return value % 1 === 0 ? value : undefined;
};
var templateObject_1;
//# sourceMappingURL=index.js.map